import {message} from 'antd';
import qs from 'qs';
import {server_address} from '@src/env-config';
import login_user_store from '@store/LoginUser/LoginUserStore';
import fetchUrl from './fetchUrl';
import global_store from '@store/Common/GlobalStore';

class Service {
    constructor() {
        // 标记 token 是否失效过期，用于处理多次弹出登录失效
        window.token_auth_overdue = false;
    }

    _beforeRequest(path, params = {}, method) {
        // 判断是否已是完整的请求地址
        let request_url = /^http/.test(path) ? path : `${server_address}${path}`;

        let request_path, opts;

        let headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        };

        if (login_user_store.token !== undefined) {
            params['token'] = login_user_store.token;
        }

        if (method.toUpperCase() === 'GET') { // get 请求，将参数放到 url 里
            request_path = `${request_url}?${qs.stringify(params)}`;
            opts = {
                method: 'GET',
                headers
            }
        } else {  // post 请求，将参数放到 request body
            request_path = request_url;
            opts = {
                method: 'POST',
                headers,
                body: qs.stringify(params)
            }
        }

        return {
            request_path,
            opts
        }
    }

    fetchData = async ({
                           path,
                           params,
                           method = 'POST',
                       }) => {
        let fetchResult;
        let {request_path, opts} = this._beforeRequest(path, params, method);
        // console.log(opts);
        let timer = setTimeout(() => {
            global_store.loading_count_add();
        }, 1000);

        if (login_user_store.token !== undefined) {
            this.hook_queue.map((fn, index) => {
                fn()
            });
        }

        return new Promise((resolve, reject) => {
            fetch(request_path, opts)
                .then(
                    async (res) => {
                        let result = await res.json();
                        clearTimeout(timer);
                        global_store.loading_count_min();

                        if (result.success === false) {
                            // 登录失效，重新登录
                            if (result.error.error_code === -2) {
                                // 记录是否已经失效，多次回调 ，只弹出一次登录失效
                                if (window.token_auth_overdue == false) {
                                    window.token_auth_overdue = true;
                                    alert(result.error.error_data);
                                    login_user_store.logout();
                                }
                            }
                        }

                        resolve(result);
                    }
                )
                .catch((err) => {
                    clearTimeout(timer);
                    global_store.loading_count_min();
                    fetchResult = {
                        success: false,
                        error: {
                            error_data: '服务器请求错误，请联系管理员',
                            error_message: '服务器请求错误，请联系管理员',
                        }
                    };
                    console.error(`${request_path} 服务器请求失败，请联系管理员`);
                    resolve(fetchResult);
                })
        })
    }

    /**
     * 钩子函数队列
     * 用户与服务器通信时，会触发队列中的函数执行
     * 目前用于刷新用户余额
     */
    hook_queue = [];

    /**
     * 添加钩子函数
     * @param {*} fn
     */
    addHookQueue(fn) {
        if (typeof fn === 'function') {
            this.hook_queue.push(fn);
        }
    }

    /**
     * 清空钩子函数队列
     */
    clearHookQueue() {
        this.hook_queue = [];
    }

    responseHandle({
                       res,
                       success_handle,
                       fail_handle,
                       final_handle
                   }) {
        // debugger;
        if (res.success === true) {
            if (success_handle && typeof success_handle === 'function') {
                success_handle(res);
            }
        } else {
            if (fail_handle && typeof fail_handle === 'function') {
                fail_handle(res);
            }
        }
        if (final_handle && typeof final_handle === 'function') {
            final_handle(res);
        }
    }

    _beforeUpload(params) {
        // 判断是否已是完整的请求地址

        let form_data = new FormData();
        form_data.append('file', params.file);
        form_data.append('path', params.upload_dir);
        let opts = {
            method: 'POST',
            headers: {},
            body: form_data
        };

        if (login_user_store.token !== undefined) {
            opts.headers['token'] = login_user_store.token;
        }

        return {
            opts
        };
    }

    // 文件上传
    uploadFile(params) {
        let fetchResult;
        let request_path = `${server_address}${fetchUrl.common.upload}`
        let {opts} = this._beforeUpload(params);
        return new Promise((resolve, reject) => {
            fetch(request_path, opts)
                .then(
                    async (res) => {
                        let result = await res.json();
                        resolve(result);
                        if (result.success === false) {
                            message.error(result.error.error_data, 3);
                        }
                    }
                )
                .catch((err) => {
                    console.error(err);
                    fetchResult = {
                        success: false,
                        error: {
                            error_data: '服务器请求错误，请联系管理员',
                            error_message: '服务器请求错误，请联系管理员',
                        }
                    };
                    reject(fetchResult);
                    message.error('服务器请求失败，请联系管理员', 3);
                });
        })
    }
}

let _service = new Service();

let _service_without_hook = new Service();

export {
    _service_without_hook
}

export default _service;



// WEBPACK FOOTER //
// ./src/service/index.js